module.exports =  function disableSubmitBtn(btn) {
	var btn,
	icon = btn.find('span.fa'),
	txt_span = btn.find('span.text'),
	txt_orig,
	txt_submit = btn.data('submit-text');
	btn.attr('disabled',true).addClass('disabled');
	if(txt_span.length) {
		txt_orig = txt_span.text();
	} else if(btn.text().length)  {
		txt_orig = btn.text();
	} else if (btn.val() !== undefined) {
		txt_orig = btn.val();
	}
	btn.data('beforeTxt',txt_orig);
	if(icon.length !== 0) {
		btn.data('beforeIcon', icon.attr('class'));
	}

	if(txt_submit === undefined) {
		txt_submit = txt_orig;
	}
	if(txt_submit === undefined) {
		txt_submit = '';
	}
	btn.html('<span class="fa fa-spinner fa-spin fa-fw"></span> ' + txt_submit);
};